<div class="w-full h-full">
  <div class="w-full h-full" *ngIf="!state.noView && state.columns">
    <y42-table-data-ag-grid
      class="w-full"
      #tableDataGrid
      *ngIf="state.serverSideDatasource"
      [datasourceTableId]="tableId"
      [columns]="state.columns"
      [cardinality]="state.cardinality"
      [cardinalityLoading]="state.cardinalityLoading"
      [previewRows]="state.previewRows"
      [totalRows]="state.rows"
      [size]="state.size"
      [showSize]="true"
      [activeHeaderColumn]="state.activeHeaderColumn"
      [activeCardinalityLoading]="state.activeCardinalityLoading"
      [activeCardinality]="state.activeCardinality"
      (submitAnalyzeColumn)="analyzeColumn($event)"
      [canEditColumn]="true"
      [showDescription]="true"
      [serverSideDatasource]="state.serverSideDatasource"
    >
    </y42-table-data-ag-grid>
    <y42-logo-loader
      *ngIf="!state.serverSideDatasource"
      class="flex justify-center items-center h-full w-full"
    ></y42-logo-loader>
  </div>
  <div *ngIf="state.noView" class="empty-table h-full w-full">
    <img class="h-[80px]" src="assets/images/not-available/no-data.svg" />
    <div class="empty-table-header">{{ state.errorMessage }}</div>
  </div>
</div>
